import { useState } from 'react';

interface DropdownOption {
  value: string | number;
  label: string;
}

interface DropdownFieldProps {
  label: string;
  value: string | number | null;
  onChange: (value: string | number | null) => void;
  required?: boolean;
  options: DropdownOption[];
  error?: string;
}

export default function DropdownField({
  label,
  value,
  onChange,
  required = false,
  options,
  error,
}: DropdownFieldProps) {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find(opt => opt.value === value);
  const displayValue = selectedOption ? selectedOption.label : 'Select...';

  return (
    <div className="relative">
      <label className="block text-xs text-gray-400 mb-1.5">
        {label}
        {required && <span className="text-red-400 ml-1">*</span>}
      </label>
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full flex items-center gap-2 px-3 py-2 bg-[#1a1f3a] border rounded-lg text-sm text-gray-300 hover:border-gray-600 transition-colors ${
          error ? 'border-red-500/50' : 'border-[#2d1b3d]'
        }`}
      >
        <span className="flex-1 text-left">{displayValue}</span>
        <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-10" onClick={() => setIsOpen(false)} />
          <div className="absolute top-full left-0 right-0 mt-1 bg-[#1a1f3a] border border-[#2d1b3d] rounded-lg shadow-xl z-20 py-1 max-h-60 overflow-y-auto">
            <button
              type="button"
              onClick={() => {
                onChange(null);
                setIsOpen(false);
              }}
              className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-[#2d1b3d] transition-colors ${
                value === null ? 'bg-[#2d1b3d]/50' : ''
              }`}
            >
              <span className="text-gray-300">None</span>
            </button>
            {options.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => {
                  onChange(option.value);
                  setIsOpen(false);
                }}
                className={`w-full flex items-center gap-2 px-3 py-2 text-sm text-left hover:bg-[#2d1b3d] transition-colors ${
                  value === option.value ? 'bg-[#2d1b3d]/50' : ''
                }`}
              >
                <span className="text-gray-300">{option.label}</span>
              </button>
            ))}
          </div>
        </>
      )}
      {error && <div className="text-xs text-red-400 mt-1">{error}</div>}
    </div>
  );
}



